var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          ref: "userDetailFrom",
          attrs: { visible: _vm.dialogUserDetail, size: "1100px" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUserDetail = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "demo-drawer_title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("div", { staticClass: "con-head" }, [
                _c("img", {
                  attrs: { src: _vm.userDetailData.avatar, alt: "" },
                }),
                _c("span", { staticClass: "nickname" }, [
                  _vm._v(_vm._s(_vm.userDetailData.nickname)),
                ]),
              ]),
              _c("div", { staticClass: "acea-row info-row" }, [
                _c("div", { staticClass: "info-row-item" }, [
                  _c("div", { staticClass: "info-row-item-title" }, [
                    _vm._v("余额"),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.userDetailData.nowMoney))]),
                ]),
                _c("div", { staticClass: "info-row-item" }, [
                  _c("div", { staticClass: "info-row-item-title" }, [
                    _vm._v("积分"),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.userDetailData.integral))]),
                ]),
                _c("div", { staticClass: "info-row-item" }, [
                  _c("div", { staticClass: "info-row-item-title" }, [
                    _vm._v("经验"),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.userDetailData.experience))]),
                ]),
                _c("div", { staticClass: "info-row-item" }, [
                  _c("div", { staticClass: "info-row-item-title" }, [
                    _vm._v("佣金"),
                  ]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.userDetailData.brokeragePrice)),
                  ]),
                ]),
                _c("div", { staticClass: "info-row-item" }, [
                  _c("div", { staticClass: "info-row-item-title" }, [
                    _vm._v("消费次数"),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.userDetailData.payCount))]),
                ]),
                _c("div", { staticClass: "info-row-item" }, [
                  _c("div", { staticClass: "info-row-item-title" }, [
                    _vm._v("连续签到"),
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.userDetailData.signNum))]),
                ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "demo-drawer__content" }, [
            _vm.userDetailData
              ? _c(
                  "div",
                  { staticClass: "description" },
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "border-card" },
                        model: {
                          value: _vm.tabsVal,
                          callback: function ($$v) {
                            _vm.tabsVal = $$v
                          },
                          expression: "tabsVal",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "0", label: "用户信息" } },
                          [
                            _c("div", { staticClass: "user-info" }, [
                              _c("div", { staticClass: "section" }, [
                                _c("div", { staticClass: "section-hd" }, [
                                  _vm._v("基本信息"),
                                ]),
                                _c("div", { staticClass: "section-bd" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("用户ID：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(_vm._s(_vm.userDetailData.uid)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("真实姓名：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.realName || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("用户账号：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.account || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("用户电话：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(_vm._s(_vm.userDetailData.phone)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("生日：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.birthday || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("性别：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userDetailData.sex == 0
                                              ? "未知"
                                              : _vm.userDetailData.sex == 1
                                              ? "男"
                                              : _vm.userDetailData.sex == 2
                                              ? "女"
                                              : "保密"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("国家：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.country == "CN"
                                            ? "中国"
                                            : "其他" || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("用户地址：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userDetailData.addres || "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "user-info" }, [
                              _c("div", { staticClass: "section" }, [
                                _c("div", { staticClass: "section-hd-other" }, [
                                  _vm._v("用户概况"),
                                ]),
                                _c("div", { staticClass: "section-bd" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("创建ip：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.userDetailData.addIp || "-")
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("注册类型：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.userDetailData.userType ==
                                              "wechat"
                                              ? "公众号"
                                              : _vm.userDetailData.userType ==
                                                "routine"
                                              ? "小程序"
                                              : _vm.userDetailData.userType ==
                                                "h5"
                                              ? "H5"
                                              : _vm.userDetailData.userType ==
                                                "iosWx"
                                              ? "微信ios"
                                              : _vm.userDetailData.userType ==
                                                "androidWx"
                                              ? "微信安卓"
                                              : "ios" || "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("添加时间：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.createTime || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("状态：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.status == true
                                            ? "正常"
                                            : "禁止" || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("最后一次登录ip：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.userDetailData.lastIp || "-")
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("最后一次登录时间：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.lastLoginTime ||
                                            "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "user-info" }, [
                              _c("div", { staticClass: "section" }, [
                                _c("div", { staticClass: "section-hd" }, [
                                  _vm._v("推广信息"),
                                ]),
                                _c("div", { staticClass: "section-bd" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("是否为团长：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.isPromoter == true
                                            ? "是"
                                            : "否" || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("下级人数：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.spreadCount || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("成为分销员时间：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.promoterTime || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("上级团长ID：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.spreadUid || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("绑定上级团长时间：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.userDetailData.spreadTime || "-"
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticClass: "user-info" }, [
                              _c("div", { staticClass: "section" }, [
                                _c("div", { staticClass: "section-hd" }, [
                                  _vm._v("用户备注"),
                                ]),
                                _c("div", { staticClass: "section-bd" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _c("div", [_vm._v("备注：")]),
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        _vm._s(_vm.userDetailData.mark || "-")
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "1", label: "消费记录" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "mt20",
                                attrs: { data: _vm.tableData, size: "small" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "orderId",
                                    label: "订单ID",
                                    "min-width": "100",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "realName", label: "收货人" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "totalNum",
                                    label: "商品数量",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "totalPrice",
                                    label: "商品总价",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "payPrice",
                                    label: "实付金额",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "payTime",
                                    label: "交易完成时间",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "2", label: "积分明细" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "mt20",
                                attrs: { data: _vm.tableData, size: "small" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "title",
                                    label: "来源/用途",
                                    "min-width": "100",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "integral",
                                    label: "积分变化",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "balance",
                                    label: "变化后积分",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "updateTime", label: "日期" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "mark", label: "备注" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "3", label: "签到记录" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "mt20",
                                attrs: { data: _vm.tableData, size: "small" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "title",
                                    label: "动作",
                                    "min-width": "100",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "number",
                                    label: "获得积分",
                                    "min-width": "120",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createTime",
                                    label: "签到时间",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "4", label: "持有优惠券" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "mt20",
                                attrs: { data: _vm.tableData, size: "small" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "name", label: "优惠券名称" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "money", label: "面值" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "endTime", label: "有效期" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "minPrice",
                                    label: "最低消费额",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "updateTime",
                                    label: "兑换时间",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "5", label: "余额变动" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "mt20",
                                attrs: { data: _vm.tableData, size: "small" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "number", label: "变动金额" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "balance", label: "变动后" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "title", label: "类型" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "add_time",
                                    label: "创建时间",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "mark", label: "备注" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-tab-pane",
                          { attrs: { name: "6", label: "好友关系" } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "mt20",
                                attrs: { data: _vm.tableData, size: "small" },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "uid", label: "ID" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "nickname", label: "昵称" },
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "level", label: "等级" },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "createTime",
                                    label: "加入时间",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.tabsVal != "0"
                      ? _c(
                          "div",
                          { staticClass: "block" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "page-size": _vm.paginationData.limit,
                                total: _vm.paginationData.total,
                                "current-page": _vm.paginationData.page,
                                background: "",
                                "page-sizes": [10, 20, 30, 40],
                                layout:
                                  "total, sizes, prev, pager, next, jumper",
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.pageChange,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }